import * as NorfolkWarehouseExpansion from './norfolk-warehouse-expansion.mdx';
import * as RecordMonthMarch from './record-month-march.mdx';
import * as EnhancedSecurityMeasures from './enhanced-security-measures.mdx';
import * as GNGAutoSalesRanks from './gng-auto-sales-ranks.mdx';
import * as UkrainePartnership from './ukraine-partnership.mdx';
import * as OngoingGlobalPresence from './ongoing-global-presence.mdx';
import * as WarehouseOpeningInVirginia from './warehouse-opening-in-virginia.mdx';
import * as OngoingCommitment from './ongoing-commitment.mdx';

export const newsArticles = [
    OngoingGlobalPresence,
    WarehouseOpeningInVirginia,
    OngoingCommitment,
];

export type NewsArticle = typeof newsArticles[0];
